import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import { Point } from "@rmlibrary/graph";
import { getLanguage } from "./utilities";

const lightblue = "#016DFF";
const lbHover = "#57A3FF";
const darkblue = "#1E3784";
const dbHover = "#83A6BE";
const axisColour = "#161616";

const lang = getLanguage();
const formatter = new Formatter(lang);

let leftScrollX = 0;

$(".bulls-graph").on("scroll", (event) => {
    leftScrollX = event.target.scrollLeft;
    const graphPopup = $("#graph-popup");
    const oldScrollX = Number(graphPopup.attr("oldscrollx"));

    graphPopup.css({ left: graphPopup.position().left - (leftScrollX - oldScrollX) });
    graphPopup.attr("oldscrollx", leftScrollX);
});

$(window).on("resize", () => {
    leftScrollX = $(".bulls-graph")[0].scrollLeft;
    const graphPopup = $("#graph-popup");
    const oldScrollX = Number(graphPopup.attr("oldscrollx"));

    graphPopup.css({ left: graphPopup.position().left - (leftScrollX - oldScrollX) });
    graphPopup.attr("oldscrollx", leftScrollX);
});

function getBullsAndBearsGraphCss() {
    const title = {
        colour: "#161616",
        font: "Roobert",
        rotateYLabel: true,
        size: 11 * devicePixelRatio,
        weight: "normal",
        xLabelTextAlign: "center",
        xLabelTextVerticalAlign: "right",
        yLabelTextAlign: "center",
        yLabelTextHorizontalAlign: "left"
    };

    const numbers = {
        xFormat: (number) => number + 1957,
        yFormat: (number) => number + "%",
        font: "Roobert",
        size: 12 * devicePixelRatio,
        padding: {
            xAxis: 10 * devicePixelRatio,
            yAxis: 10 * devicePixelRatio
        },
        xAxisWeight: "normal",
        yAxisWeight: "normal",
        colour: "#161616"
    };

    const axisCss = {
        axisLineWidth: 1 * devicePixelRatio,
        axisLineColour: axisColour,
        gridLineWidth: 1,
        gridLineColour: axisColour,
        title,
        numbers
    };

    const padding = {
        left: 70 * devicePixelRatio,
        right: 10 * devicePixelRatio,
        top: 10 * devicePixelRatio,
        bottom: 60 * devicePixelRatio
    };

    const canvasCss = { padding };

    const titleCss = {
        font: "Roobert-bold",
        weight: "bold",
        size: 20,
        colour: "#161616",
        textAlign: "center"
    };

    return {
        axisCss,
        canvasCss,
        titleCss
    };
}

function getBullsAndBearsGraphOptions(
    bullsAndBearsArray,
    { bullsPoints, bearsPoints, bullsBarsWidths, bearsBarsWidths }
) {
    const yMinValue = bullsAndBearsArray.reduce(
        (minValue, { percentValue }) => Math.min(minValue, percentValue),
        bullsAndBearsArray[0].percentValue
    );
    const yMaxValue = bullsAndBearsArray.reduce(
        (maxValue, { percentValue }) => Math.max(maxValue, percentValue),
        bullsAndBearsArray[0].percentValue
    );

    const startingYear = bullsAndBearsArray[0].startYear;
    const currentYear = 2030;

    const yMinRange = Math.floor((yMinValue * 100) / 50) * 50;
    const yMaxRange = Math.ceil((yMaxValue * 100) / 50) * 50;

    const ticksToRemove = [];

    let index = 0;

    for (let i = 0; i < currentYear - startingYear; i++) {
        if ((i + 1957) % 5 !== 0) {
            ticksToRemove.push(i);
        }
    }

    const axisOptions = {
        xAxis: {
            name: lang === "en" ? "Year" : "Année",
            drawGridLines: false,
            drawAxisLine: true,
            range: [0, currentYear - startingYear],
            ticks: currentYear - startingYear + 1,
            removeTicks: ticksToRemove,
            drawTicks: (ctx, x, y) => {
                ctx.save();

                ctx.beginPath();
                ctx.strokeStyle = axisColour;
                ctx.lineWidth = devicePixelRatio;
                ctx.moveTo(x, y);
                ctx.lineTo(x, y + 7 * devicePixelRatio);
                ctx.stroke();

                ctx.restore();
            }
        },
        yAxis: {
            name: lang === "en" ? "Percentage market gain/loss" : "Gains et pertes du marché (%)",
            drawGridLines: false,
            drawAxisLine: true,
            range: [yMinRange, yMaxRange],
            ticks: (yMaxRange - yMinRange) / 50 + 1, // each tick is incremented by 50
            drawTicks: (ctx, x, y) => {
                if (index === 1 || index === (yMaxRange - yMinRange) / 50) {
                    index++;
                    return;
                }
                ctx.save();

                ctx.beginPath();
                ctx.strokeStyle = axisColour;
                ctx.lineWidth = devicePixelRatio;
                ctx.moveTo(x, y);
                ctx.lineTo(x + 7 * devicePixelRatio, y);
                ctx.stroke();

                ctx.restore();
                index++;
            },
            offset: "bottom"
        }
    };

    const graphHover = document.getElementById("graph-hover-overlay");
    const graphPopup = document.getElementById("graph-popup");

    const events = {
        hoverOn: (dataName, x, y, xPos, yPos, xValOnGraph, yValOnGraph) => {
            const point = [...bullsPoints, ...bearsPoints].filter((point) => {
                return point.x === x && point.y === y;
            })[0];

            // const scaleRatio =
            let numberOfMonths = 0;

            if (point.y < 0) {
                numberOfMonths = bearsBarsWidths[bearsPoints.indexOf(point)];
            } else {
                numberOfMonths = bullsBarsWidths[bullsPoints.indexOf(point)];
            }

            const hoverTop =
                point.y < 0 ? yValOnGraph - Math.abs(point.coords.y2 - point.coords.y1) + 1 : yValOnGraph + 1;
            graphHover.style.backgroundColor = point.y < 0 ? dbHover : lbHover;

            graphHover.style.top = hoverTop + "px";
            graphHover.style.left = xValOnGraph + "px";
            graphHover.style.width = Math.abs(point.coords.x2 - point.coords.x1) + 1 + "px"; // TODO: might have issues
            graphHover.style.height = Math.abs(point.coords.y2 - point.coords.y1) + "px";
            graphHover.style.display = "block";

            graphPopup.style.display = "block";
            const relativeWidth = $("#bulls-and-bears-graph").outerWidth() * devicePixelRatio * 0.03;
            let popupTop =
                (point.y < 0 ? yValOnGraph - Math.abs(point.coords.y2 - point.coords.y1) - 20 : yValOnGraph - 45) -
                graphPopup.offsetHeight;

            graphPopup.innerHTML = `
                <span class="duration-text">${lang === "en" ? "Duration" : "Durée"}:</span> 
                <b>${numberOfMonths * 12} ${lang === "en" ? "Months" : "Mois"}</b>`;
            graphPopup.style.left =
                xValOnGraph +
                Math.abs(point.coords.x2 - point.coords.x1) / 2 -
                graphPopup.offsetWidth / 2 -
                leftScrollX +
                "px";
            graphPopup.style.top = popupTop + "px";
        },
        hoverOff: () => {
            graphHover.style.display = "none";
            graphPopup.style.display = "none";
        },
        clickOn: (dataName, x, y, xPos, yPos, xValOnGraph, yValOnGraph) => {
            const point = [...bullsPoints, ...bearsPoints].filter((point) => {
                return point.x === x && point.y === y;
            })[0];

            let numberOfMonths = 0;

            if (point.y < 0) {
                numberOfMonths = bearsBarsWidths[bearsPoints.indexOf(point)];
            } else {
                numberOfMonths = bullsBarsWidths[bullsPoints.indexOf(point)];
            }

            const hoverTop =
                point.y < 0 ? yValOnGraph - Math.abs(point.coords.y2 - point.coords.y1) + 1 : yValOnGraph + 1;
            graphHover.style.backgroundColor = point.y < 0 ? dbHover : lbHover;

            graphHover.style.top = hoverTop + "px";
            graphHover.style.left = xValOnGraph + "px";
            graphHover.style.width = Math.abs(point.coords.x2 - point.coords.x1) + 1 + "px";
            graphHover.style.height = Math.abs(point.coords.y2 - point.coords.y1) + "px";
            graphHover.style.display = "block";

            graphPopup.style.display = "block";
            let popupTop =
                (point.y < 0 ? yValOnGraph - Math.abs(point.coords.y2 - point.coords.y1) : yValOnGraph) -
                graphPopup.offsetHeight -
                20;

            if (popupTop < 0) {
                popupTop = 0;
            }

            const oldScrollX = Number(graphPopup.getAttribute("oldscrollx"));
            graphPopup.innerHTML =
                `${lang === "en" ? "Duration" : "Durée"}: <b>` +
                numberOfMonths * 12 +
                ` ${lang === "en" ? " Months" : " Mois"} </b>`;
            graphPopup.style.left =
                xValOnGraph +
                Math.abs(point.coords.x2 - point.coords.x1) / 2 -
                graphPopup.offsetWidth / 2 -
                oldScrollX +
                "px";
            graphPopup.style.top = popupTop + "px";
        },
        clickOff: () => {
            graphHover.style.display = "none";
            graphPopup.style.display = "none";
        }
    };

    return {
        accessibilityTable: false,
        autoResize: false,
        axisOptions,
        events,
        pixelRatio: devicePixelRatio,
        title: ""
    };
}

function calculateNumberOfMonthsPerPeriod(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return (d2.getFullYear() - d1.getFullYear()) * 12 + (d2.getMonth() - d1.getMonth());
}

function getBullsAndBearsPointsAndWidths(bullsAndBearsArray) {
    let startXForPoint = 0;
    const bullsPoints = [];
    const bearsPoints = [];
    const bullsBarsWidths = [];
    const bearsBarsWidths = [];

    bullsAndBearsArray.forEach(({ numberOfMonths, percentValue }, index) => {
        const numMonths = numberOfMonths / 12;

        if (percentValue >= 0) {
            bullsPoints.push(
                new Point(startXForPoint, Number((percentValue * 100).toFixed(0)), (ctx, x, y, w, h) => {
                    const relativeWidth = $("#bulls-and-bears-graph").outerWidth() * devicePixelRatio;
                    ctx.save();

                    ctx.fillStyle = "black";
                    ctx.textAlign = "start";
                    //NOTE: this changes the "39 %" font size in fr because it gets cut off
                    const defaultMultiplier = 0.016;
                    const bull5Multiplier = 0.014;
                    const multiplier = lang === "fr" && index === 9 ? bull5Multiplier : defaultMultiplier;
                    ctx.font = `bold ${relativeWidth * multiplier}px Roobert`;
                    ctx.fillText(formatter.formatPercentage(percentValue * 100, 0), x, y - relativeWidth * 0.018);

                    ctx.restore();
                })
            );
            bullsBarsWidths.push(numMonths);
        } else {
            bearsPoints.push(
                new Point(startXForPoint, Number((percentValue * 100).toFixed(0)), (ctx, x, y, w, h) => {
                    const relativeWidth = $("#bulls-and-bears-graph").outerWidth() * devicePixelRatio;
                    ctx.save();

                    ctx.fillStyle = darkblue;
                    ctx.textAlign = "start";
                    ctx.font = `bold ${relativeWidth * 0.016}px Roobert`;
                    if (Number((percentValue * 100).toFixed(0)) === -23) {
                        x -= relativeWidth * 0.015;
                    } else if (Number((percentValue * 100).toFixed(0)) === -27) {
                        ctx.textAlign = "center";
                    }
                    ctx.fillText(formatter.formatPercentage(percentValue * 100, 0), x, y + relativeWidth * 0.018);

                    ctx.restore();
                })
            );
            bearsBarsWidths.push(numMonths);
        }

        startXForPoint += numMonths;
    });

    return {
        bullsPoints,
        bearsPoints,
        bullsBarsWidths,
        bearsBarsWidths
    };
}

function getBullsAndBearsDataset(bullsAndBearsArray, { bullsPoints, bearsPoints, bullsBarsWidths, bearsBarsWidths }) {
    let dataset = [
        {
            css: {
                width: 1,
                fillColour: lightblue,
                individualWidths: bullsBarsWidths,
                justify: "none"
            },
            points: bullsPoints,
            name: "Bull Markets",
            type: "bar"
        },
        {
            css: {
                width: 1,
                fillColour: darkblue,
                individualWidths: bearsBarsWidths,
                justify: "none"
            },
            points: bearsPoints,
            name: "Bears Markets",
            type: "bar"
        },
        {
            points: [new Point(0, 0)],
            name: "offset x-axis",
            css: {
                width: 1 * devicePixelRatio,
                colour: axisColour
            },
            isHorizontal: true,
            type: "dashedLine"
        }
    ];

    return dataset;
}

export {
    getBullsAndBearsGraphCss,
    calculateNumberOfMonthsPerPeriod,
    getBullsAndBearsGraphOptions,
    getBullsAndBearsDataset,
    getBullsAndBearsPointsAndWidths
};
